import { render, staticRenderFns } from "./UserPermission.vue?vue&type=template&id=0cffe14d"
import script from "./UserPermission.vue?vue&type=script&lang=js"
export * from "./UserPermission.vue?vue&type=script&lang=js"
import style0 from "./UserPermission.vue?vue&type=style&index=0&id=0cffe14d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports